import{reactive}from'vue';

export type FeedbackKind='success'|'error';
export interface FeedbackMessage{id:number;kind:FeedbackKind;text:string}

const messages=reactive<FeedbackMessage[]>([]);
let nextId=1;

function push(kind:FeedbackKind,text:string):void{
  const id=nextId++;
  messages.push({id,kind,text});
  window.setTimeout(()=>remove(id),4200);
}

export function remove(id:number):void{
  const index=messages.findIndex(item=>item.id===id);
  if(index>=0)messages.splice(index,1);
}

export function useFeedback(){
  return{messages,remove,success:(text:string)=>push('success',text),error:(text:string)=>push('error',text)};
}
